import * as React from 'react';

class CloseBtnSvg extends React.Component<Svg.IProps, Svg.IState> {
  static defaultProps: Svg.IProps = { className: '' };

  render() {
    const { className, ...rest } = this.props;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        className={`svg-icon close-btn-svg ${className || 'm-3'}`}
        {...rest}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24 12L23.9998 11.9998C23.9998 9.19588 23.7425 6.392 23.228 3.588C22.9275 1.952 21.6945 0.8075 20.116 0.496C17.692 0.0595 12 0 12 0L11.9998 0.000248909V0C11.9998 0 6.30775 0.0595 3.88375 0.496C2.30525 0.8075 1.07225 1.952 0.77175 3.588C0.257235 6.39208 -1.52549e-05 9.19604 6.78478e-10 12C1.52553e-05 14.8038 0.257265 17.6076 0.77175 20.4115C1.07225 22.0475 2.30525 23.19 3.88375 23.5015C6.61525 23.9465 11.9998 24 11.9998 24V23.9998L12 24C12 24 17.3845 23.9465 20.116 23.5015C21.6945 23.19 22.9275 22.0475 23.228 20.4115C23.7425 17.6077 23.9997 14.804 23.9998 12.0002L24 12Z"
          fill="#EA1C0A"
        />
        <path
          d="M12.705 12L16.35 8.35501C16.4319 8.25936 16.4747 8.13633 16.4699 8.01049C16.465 7.88465 16.4128 7.76528 16.3238 7.67623C16.2347 7.58718 16.1154 7.53502 15.9895 7.53016C15.8637 7.5253 15.7407 7.5681 15.645 7.65001L12 11.295L8.35501 7.65001C8.25936 7.5681 8.13633 7.5253 8.01049 7.53016C7.88465 7.53502 7.76528 7.58718 7.67623 7.67623C7.58718 7.76528 7.53502 7.88465 7.53016 8.01049C7.5253 8.13633 7.5681 8.25936 7.65001 8.35501L11.295 12L7.65001 15.645C7.5681 15.7407 7.5253 15.8637 7.53016 15.9895C7.53502 16.1154 7.58718 16.2347 7.67623 16.3238C7.76528 16.4128 7.88465 16.465 8.01049 16.4699C8.13633 16.4747 8.25936 16.4319 8.35501 16.35L12 12.705L15.645 16.35C15.7407 16.4319 15.8637 16.4747 15.9895 16.4699C16.1154 16.465 16.2347 16.4128 16.3238 16.3238C16.4128 16.2347 16.465 16.1154 16.4699 15.9895C16.4747 15.8637 16.4319 15.7407 16.35 15.645L12.705 12Z"
          fill="#EA1C0A"
        />
      </svg>
    );
  }
}

export default CloseBtnSvg;
